import { MAP_TYPES } from '@deck.gl/carto';
 
const SYSTEMICSEGMENT_SOURCE_ID = 'systemicSegmentSource';
 
const source = {
  id: SYSTEMICSEGMENT_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'cartointegration',
  data: 'systemic_segment_source',
};
 
export default source;
 